import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { MembershipConfiguration } from 'src/features/membership/types';

const RESOURCE = 'sp-core/:parkingId/memberships/membership/:membershipId/current-configuration/';

type QueryFnType = typeof queryFn;

interface DTO {
    membershipId: string;
    parkingId: string;
}
const queryFn = ({ parkingId, membershipId }: DTO): Promise<MembershipConfiguration> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        staleTime: 1000 * 60 * 10,
        ...config,
    });

export { RESOURCE as MEMBERSHIP_CONFIGURATION_RESOURCE, useQueryHook as useGetMembershipConfiguration };
